'use strict';

function common(g) {
  function init() {
    // code ici
  }

  init();
}
